import { useDispatch } from 'react-redux';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { ShareUserType } from '../models';
import { setVisibleShareDashboard } from '../store';

export function useShareDashboard() {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async (payload: { id: number; employees: ShareUserType[] }) => {
      const { data } = await $api.post('/v1/dashboard/share', payload);

      return data;
    },
    onSuccess: res => {
      showMessage(res.message, true);

      dispatch(setVisibleShareDashboard(false));
    },
    onError: baseErrorHandler
  });
}
